import type * as SchemaTypes from '../types';

import { gql } from '@apollo/client';
export type CustomerListEndpointContextDataFragment = (
  { __typename: 'CustomerListEndpoint' }
  & Pick<SchemaTypes.CustomerListEndpoint, 'id' | 'title' | 'applicationModuleIds'>
);

export const CustomerListEndpointContextDataFragmentDoc = /*#__PURE__*/ gql`
    fragment CustomerListEndpointContextData on CustomerListEndpoint {
  id
  title
  applicationModuleIds
}
    `;